$( document ).on( "variant:change", function( evt, variant ) {
    const variant_id = variant.id;
    // console.log("variant:change => ", variant)
    if (!variant) return;

  const sectionId = document.querySelector('[data-product-section]').getAttribute('data-section-id'); // Or the dynamic section ID of the product template
  const productHandle = window.location.pathname.split('/').pop();
  const fetchUrl = `${window.location.pathname}?variant=${variant_id}&section_id=${sectionId}`;

  fetch(fetchUrl)
    .then(response => response.text())
    .then(text => {
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(text, 'text/html');

      // Updating indicators
      updatingIndicators(htmlDoc);

      // Update Fast Delivery Block
      updatingFastDeliveryBlock(htmlDoc);
    })
    .catch(console.error);
});

function updatingIndicators(newHtmlDoc) {
    // Getting the colors that have active indicators
    const newSwatcheActiveIndicators = newHtmlDoc.querySelectorAll('.swatch.is-color .fast-delivery-indicator.active');
    const newSwatcheActiveIndicatorColors = [];
    newSwatcheActiveIndicators.forEach(indicator => {
    const color = indicator.getAttribute('data-color');
    newSwatcheActiveIndicatorColors.push(color);
    });

    // Remove active class from all indicators
    const currentSwatchesIndicators = document.querySelectorAll('.swatch.is-color .fast-delivery-indicator');
    currentSwatchesIndicators.forEach(indicator => {
    indicator.classList.remove('active');
    });

    // Add active class to indicators that have active indicators in the new HTML
    newSwatcheActiveIndicators.forEach(indicator => {
    document.querySelector(`.fast-delivery-indicator[data-color="${indicator.getAttribute('data-color')}"]`).classList.add('active');
    });
}

function updatingFastDeliveryBlock(newHtmlDoc) {
    const newDeliveryDate = newHtmlDoc.querySelector('.product-delivery-dates span[data-delivery-date]');
    const currentDeliveryDate = document.querySelector('.product-delivery-dates span[data-delivery-date]');
    if (currentDeliveryDate) {
        currentDeliveryDate.replaceWith(newDeliveryDate);
    }
}
    